export default [
  {
    path: '/page_report_distributeView_index',
    component: resolve => require(['../page/report/distributeView/index.vue'], resolve)
  },
]



// WEBPACK FOOTER //
// ./src/router/distributeShow.js